import { ApiService } from '../parents/api.service';
import { HttpApiClient } from '../api/http-api-client';

export class CreditCouponStatusApiService extends ApiService {
  static endpoint = 'credit-coupon-status';

  /**
   * @param {object} data
   * @param {function} builderCallback
   * @param {object} config
   * @public
   */
  static post(data, builderCallback = null, config = {}) {
    return HttpApiClient.post(this.buildUrl(), data, {
      ...config,
      useThemeApi: true,
      params: this.prepareUrlBuilder(builderCallback).getUrlParameters(),
    });
  }
}
